//
//
//
//
//
//
//

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {

    }
  }
}



// WEBPACK FOOTER //
// ./src/common/components/noData/index.vue